import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { pollTransferForSingleStatusChange } from '../../../services/transfers';
import { useAppSelector } from '../../../../../stores/redux-store';
import { Transfer } from '../../../../DirectPayments/models/transfer';
import { Api } from '../../../../../lib-api/Api';
import { signCredentials as signCredentialsImport } from '../../../../../connectivity/services/credentials';

type UseTransferPollerArgs = {
  TransferApi?: typeof Api.Transfer;
  signCredentials?: typeof signCredentialsImport;
  timer?: (callback: () => void, ms: number) => void;
};

export const useTransferPoller = ({
  TransferApi = Api.Transfer,
  signCredentials = signCredentialsImport,
  timer = setTimeout,
}: UseTransferPollerArgs = {}) => {
  const dispatch = useDispatch();
  const transfer = useAppSelector((state) => state.transfer.data!);
  const credentialsId = useAppSelector((state) => state.credentials.data!.id);

  useEffect(() => {
    if (Transfer.isAwaiting(transfer)) {
      signCredentials({ credentialsId, dispatch });
    }
  }, [signCredentials, transfer, credentialsId, dispatch]);

  useEffect(() => {
    dispatch(pollTransferForSingleStatusChange(transfer, TransferApi, timer));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
